import {
  Card,
  CardContent,
  CardHeader,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import DashboardLayout from "../layoutcontainers/DashboardLayout";
import { useContext, useEffect, useState } from "react";
import axios from "axios";
import BASEURL from "./Utils/Baseurl";
import MaterialButton from "../components/MaterialButton";
import { DesignationContext } from "../context/designationcontext";
import { useNavigate } from "react-router-dom";
import { useUserDetails } from "../context/auth";
import Swal from "sweetalert2";
import ConfirmationDialog from "../components/Dialog/ConfirmationDialog";
const PermissionApproval = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const id = queryParams.get("id");
  let Roledata = JSON.parse(sessionStorage.getItem("permission"));
  let userdata = JSON.parse(sessionStorage.getItem("user"));
  console.log("userdata",userdata);
  
  const [display, setdisplay] = useState(false);
  const [employeeData, setemployedata] = useState({});
  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });

  const getpermission = `
      

    query PermissionRequestById($id: ID!){ 

  permissionById(id: $id){ 

    data{ 

      user{ 

      id 

      firstName 

      lastName 

      email 

    } 

    permissionOn 

    permissionFrom 

    permissionTill 
    reason
   balanceHours
    status 
    teamApproval 

      hrApproval 

    approvalStatus{ 

      id 

      approver{ 

        id 

        firstName 

        lastName 

        email 

      } 

      status 

    } 

     

    } 

    message 

    success 

    error 

  } 

} 
        
    
        `;
  const nav = useNavigate();

  const handleclose = () => {
    nav("/permission");
  };

  const handleAddLeave = (statusdata) => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: `Are you sure you want to ${
        statusdata == "approved"
          ? "Approve"
          : statusdata == "rejected"
          ? "Reject"
          : ""
      } the permission?`,
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        ApproveSubmit(statusdata);
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  //   const ApproveSubmit = (status) => {
  //     if (designation.value == "Team List") {
  //       const approvebymanager = `
  //                 mutation ApprovePermissionManager($id: String!, $status: String!, $approver_id: ID!){

  //    PermissionApprovalManager(id: $id, status: $status, approverId: $approver_id) {

  //      permissionApprovalManager {

  //        id

  //        teamApproval

  //        hrApproval

  //        status

  //      }

  //     message

  //     error

  //     success

  //    }

  // }

  //                 `;

  //       const Approval = async () => {
  //         try {
  //           const response = await axios.post(
  //             BASEURL,
  //             {
  //               query: approvebymanager,
  //               variables: {
  //                 id: id,
  //                 status: status,
  //                 approver_id: userdata?.id,
  //               },
  //             },
  //             {
  //               headers: {
  //                 "Content-Type": "application/json",
  //               },
  //             }
  //           );

  //           let result =
  //             response.data.data?.PermissionApprovalManager
  //               ?.permissionApprovalManager;

  //           if (result.status) {
  //             Swal.fire({
  //               position: "center",
  //               icon: "success",
  //               title: `${
  //                 status.charAt(0).toUpperCase() + status.slice(1)
  //               } successfully!`,
  //               showConfirmButton: false,
  //               timer: 2500,
  //             });
  //             nav("/permission");
  //           }
  //         } catch (error) {
  //           console.log(error, "err");
  //         }
  //       };

  //       Approval();
  //     } else if (designation.value == "HR List") {
  //       const ApproveHr = `
  //                    mutation ApprovePermissionHR($id: String!, $status: String!) {
  //              PermissionApprovalHR(id: $id, status: $status) {
  //            permissionApprovalHR {
  //               id
  //             teamApproval
  //           hrApproval
  //             status
  //               }
  //         }
  //             }

  //                 `;

  //       const Approval = async () => {
  //         try {
  //           const response = await axios.post(
  //             BASEURL,
  //             {
  //               query: ApproveHr,
  //               variables: {
  //                 id: id,
  //                 status: status,
  //               },
  //             },
  //             {
  //               headers: {
  //                 "Content-Type": "application/json",
  //               },
  //             }
  //           );

  //           let result =
  //             response.data.data?.PermissionApprovalHR?.permissionApprovalHR;

  //           if (result.status == "approved") {
  //             Swal.fire({
  //               position: "center",
  //               icon: "success",
  //               title: `${
  //                 status.charAt(0).toUpperCase() + status.slice(1)
  //               } successfully!`,
  //               showConfirmButton: false,
  //               timer: 2500,
  //             });
  //             nav("/permission");
  //           }
  //         } catch (error) {
  //           console.log(error, "err");
  //         }
  //       };

  //       Approval();
  //     } else {
  //       console.log("click");
  //     }
  //   };
  const ApproveSubmit = async (statusdata) => {
    let query;
    let variables;

    if (employeeData?.approvalStatus !== null) {
      query = `
    mutation ApprovePermissionManager($id: String!, $status: String!, $approver_id: ID! $screen_name: String!){  
 
   PermissionApprovalManager(id: $id, status: $status, approverId: $approver_id screenName:$screen_name) {  
 
     permissionApprovalManager {  
 
       id
 
      user {
 
        id
 
        empid
 
        firstName
 
      }
 
      permissionOn
 
      permissionFrom
 
      permissionTill
 
      reason
 
      status
 
      teamApproval
 
      hrApproval
 
      balanceHours
 
      createdAt 
      approvalStatus{
        id
        approver{
          id
          firstName
          lastName
        }
        status
      }
 
    } 

 
    message
 
    success
 
    error
 
     
 
   }  
 
}
    `;

      variables = {
        id: +id,
        status: statusdata,
        approver_id: userdata?.id,
        screen_name: "Permission Approval",
      };
    } else {
      // HR approval
      query = `
     mutation ApprovePermissionHr($id: String! $status: String!){  
 
   PermissionApprovalHR(id: $id, status: $status) {  
 
     permissionApprovalHR {  
 
       id
 
      user {
 
        id
 
        empid
 
        firstName
 
      }
 
      permissionOn
 
      permissionFrom
 
      permissionTill
 
      reason
 
      status
 
      teamApproval
 
      hrApproval
 
      balanceHours
 
      createdAt 
      approvalStatus{
        id
        approver{
          id
          firstName
          lastName
        }
        status
      }
 
    } 

 
    message
 
    success
 
    error
 
     
 
   }  
 
}
    `;

      variables = {
        id: id,
        status: statusdata,
      };
    }

    try {
      const response = await axios.post(
        BASEURL,
        {
          query,
          variables,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      setConfirmationDialog((prev) => ({
        ...prev,
        open: false,
      }));

      const isHRSuccess =
        response.data.data?.PermissionApprovalHR?.permissionApprovalHR !== null;
      const isManagerSuccess =
        response.data.data?.PermissionApprovalManager
          ?.permissionApprovalManager !== null;

      if (isHRSuccess || isManagerSuccess) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: `${
            statusdata.charAt(0).toUpperCase() + statusdata.slice(1)
          } successfully!`,
          showConfirmButton: false,
          timer: 2500,
        });
        nav("/permission");
      } else {
        Swal.fire({
          icon: "error",
          title: "Approval Failed",
          text: "Something went wrong. Please try again.",
        });
      }
    } catch (error) {
      console.error("Error in ApproveSubmit:", error);
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "Something went wrong while submitting. Please try again later.",
      });
    }
  };
  useEffect(() => {
    if (id) {
      const fetchpermission = async () => {
        try {
          const response = await axios.post(
            BASEURL,
            {
              query: getpermission,
              variables: { id },
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
          const permissionData = response.data.data.permissionById?.data[0];
          setemployedata(response.data.data.permissionById?.data[0]);
          if (
            // userdata.designation == "HR" &&
            Roledata == "HR List" &&
            permissionData.teamApproval === "approved" &&
            permissionData.hrApproval === "pending"
          ) {
            setdisplay(true);
          }
        } catch (error) {
          console.log(error, "err");
        }
      };

      fetchpermission();
    }
  }, [id]);

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
      <Card sx={{ padding: 2, boxShadow: 3 }}>
        <CardHeader
          title={
            <Stack direction="column" spacing={0}>
              <Typography variant="h5" fontWeight="bold" textAlign="center">
                Permission Details
              </Typography>
            </Stack>
          }
        />
        <CardContent>
          <Grid container spacing={1} marginLeft={"4%"}>
            {/* Left Column */}
            <Grid item xs={12} sm={6}>
              <Stack spacing={2}>
                <Typography variant="h6">
                  <strong>User Name:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData?.user?.firstName?.toUpperCase()}
                  </span>
                </Typography>
                <Typography variant="h6">
                  <strong>Permission On:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData?.permissionOn}
                  </span>
                </Typography>
                <Typography variant="h6">
                  <strong>Permission From:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData?.permissionFrom}
                  </span>
                </Typography>
                <Typography variant="h6">
                  <strong> Permission Till:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData?.permissionTill}
                  </span>
                </Typography>
                <Typography variant="h6">
                  <strong>Balance Hours:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData?.balanceHours}
                  </span>
                </Typography>
              </Stack>
            </Grid>

            {/* Right Column */}
            <Grid item xs={12} sm={6}>
              <Stack spacing={2}>
                <Typography variant="h6">
                  <strong>Reason:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData?.reason}
                  </span>
                </Typography>

                <Typography variant="h6">
                  <strong>Status:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData?.status}
                  </span>
                </Typography>
                {/* <Typography variant="h6">
                    <strong>Created AT:</strong>{" "}
                    <span style={{ color: "#67748E" }}>
                    {employeeData?.createdAt}
      
                      </span>
                  </Typography> */}
              </Stack>
            </Grid>
          </Grid>

          {/* Close and Action Buttons */}
          <Grid container spacing={2} justifyContent="center" marginTop={4}>
            {(employeeData?.approvalStatus?.approver?.id == userdata?.id ||
              display) && (
              <>
                <Grid item>
                  <MaterialButton
                    variant="contained"
                    color="primary"
                    onClick={() => handleAddLeave("approved")}
                  >
                    Approve
                  </MaterialButton>
                </Grid>
                <Grid item>
                  <MaterialButton
                    variant="contained"
                    color="secondary"
                    onClick={() => handleAddLeave("rejected")}
                  >
                    Reject
                  </MaterialButton>
                </Grid>
              </>
            )}
            <Grid item>
              <MaterialButton
                variant="contained"
                color="dark"
                // sx={{ backgroundColor: "darkgray", color: "white" }}
                onClick={() => handleclose()}
              >
                Close
              </MaterialButton>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </DashboardLayout>
  );
};

export default PermissionApproval;